import { Reveal, Overline } from "./Reveal";

const IMG = "https://static.prod-images.emergentagent.com/jobs/aac30769-f491-4e91-84b6-42abbea5b108/images/480ed47abb8837de4d45868c027f49c82d0159dab0458873a2209c646b6a7ef8.jpeg";

export const Benefits = ({ t }) => (
  <section
    id="benefits"
    data-testid="benefits-section"
    className="relative z-10 py-24 md:py-36"
  >
    <div className="absolute inset-0">
      <img
        src={IMG}
        alt="Classical premium architecture"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/82" />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/50" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6">
      <Reveal>
        <Overline testId="benefits-overline">{t.benefits.overline}</Overline>
        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[1.05] max-w-3xl">
          {t.benefits.title}
        </h2>
        <p className="text-white/65 text-lg leading-relaxed mt-8 max-w-2xl">
          {t.benefits.text}
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-3 gap-8 mt-16 max-w-4xl">
        {t.benefits.stats.map((s, i) => (
          <Reveal key={i} delay={i * 0.12}>
            <div className="border-t border-[#D4AF37]/40 pt-6">
              <p className="font-display text-5xl md:text-6xl gold-gradient-text">
                {s.value}
              </p>
              <p className="text-white/55 mt-3 tracking-wide">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
